/**
 * Format an ISO 8601 timestamp as a compact local-time string (HH:MM).
 * Returns null for missing or unparseable values so callers can skip rendering.
 */
const TIME_FORMAT_OPTIONS = { hour: '2-digit', minute: '2-digit', hour12: false }

export function formatUpdatedTime(isoString) {
  if (!isoString) return null
  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleTimeString(undefined, TIME_FORMAT_OPTIONS)
}
